<template>
    <v-layout wrap justify-content align-center>

        <v-flex xs4 align-center justify-center text-center>
            <appointment-type-button
                    value="individual"
                    icon="fa-user"
                    @click="type = $event"
                    :active="type === 'individual'"
                    label="Individual" />
        </v-flex>

        <v-flex xs4 align-center justify-center text-center>
            <appointment-type-button
                    value="two"
                    icon="fa-user-friends"
                    @click="type = $event"
                    :active="type === 'two'"
                    label="Pareja" />
        </v-flex>

        <v-flex xs4 align-center justify-center text-center>
            <appointment-type-button
                    value="group"
                    icon="fa-users"
                    @click="type = $event"
                    :active="type === 'group'"
                    label="Grupal" />
        </v-flex>

    </v-layout>
</template>


<script>

    import AppointmentTypeButton from '../AppointmentTypeButton.vue'

    export default{
        components: {AppointmentTypeButton},
        data(){
            return {
                type: 'individual'
            }
        },
        watch:{
            type(val){
                this.$emit('change', val)
            }
        }
    }
</script>
